import React from "react";
import { TabsSkeleton } from "@features/skeletons/common/TabsSkeleton/TabsSkeleton";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface AdditionalServicesSkeletonProps {
  count?: number;
}

export const AdditionalServicesSkeleton: React.FC<
  AdditionalServicesSkeletonProps
> = ({ count = 6 }) => (
  <TabsSkeleton>
    <div className="grid grid-cols-[repeat(auto-fill,minmax(320px,1fr))] gap-6">
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="w-full overflow-hidden rounded-xl border border-[#DEDEDE] shadow-sm"
          >
            <Skeleton variant="rectangular" className="h-[191px]" />

            <div className="flex flex-row items-center justify-between p-6">
              <div className="flex flex-col gap-2">
                <Skeleton className="w-[120px] text-sm" />
                <Skeleton className="text-md w-[100px]" />
              </div>
            </div>
          </div>
        ))}
    </div>
  </TabsSkeleton>
);
